import { getTopUsageRankAPI } from "@/apis/usage-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { create } from "zustand"

export const topUsageRankStore = create((set) => ({
  topRankMap: {},

  apiGetTopUsageRank: async () => {
    const { sido, kapt_code, ended_at } = aptSearchStore.getState().pickApt
    const topRankMap = await getTopUsageRankAPI({ sido, kapt_code, ended_at })
    set({ topRankMap })
  }
}))
